import { type FC } from 'react';
import { observer } from 'mobx-react-lite';
import { ProgressBar } from '@sbol/nova';
import type { Survey } from '../logic';
import styles from './SurveyProgressBar.module.scss';

export const SurveyProgressBar: FC<{ survey: Survey }> = observer(({ survey }) => {
  if (!survey.maxProgressStepsCount) {
    return <div className={styles.EmptyPlace} />;
  }

  return <ProgressBar progress={survey.progress} type="fat" className={styles.SurveyProgressBar} />;
});
